import { createCollection } from 'utils/create-collection/create-collection';
import type { Board } from 'chessboard/model/board/types';
import type { Game } from 'chessboard/model/game/types';
import type { API } from 'chessboard/api/config/types';

/**
 * Create the getPieces method.
 */
export function createGetPieces(context: API.Context) {
  /**
   * Get the pieces collection.
   */
  return function getPieces(): Game.Piece.Collection {
    const { game } = context;

    return createCollection<Game.Piece.Model, Board.SanSquare>(game.getPieces(true));
  };
}
